export enum TeamVisibility {
  Public = 1,
  Private = 2,
}

export interface TeamDto {
  id: string;
  name: string;
  description?: string | null;
  avatarUrl?: string | null;
  coverImageUrl?: string | null;
  phones?: TeamContactItem[];
  links?: TeamContactItem[];
  addresses?: TeamContactItem[];
  visibility: TeamVisibility;
  inviteCode?: string;
  createdByUserId: string;
  membersCount: number;
  myRole?: number | null;
  myBadgeTitle?: string | null;
  myTeamJerseyNumber?: number | null;
  allowDuplicateJerseyNumbers?: boolean;
  blockedJerseyNumbers?: number[];
}

export interface TeamContactItem {
  title: string;
  value: string;
}

export interface TeamMemberDto {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  jerseyNumber?: number | null;
  photoUrl?: string | null;
  role: number;
  badgeTitle?: string | null;
  teamJerseyNumber?: number | null;
}

export interface TeamNewsDto {
  id: string;
  teamId: string;
  teamName?: string | null;
  title: string;
  body: string;
  imageUrl?: string | null;
  authorUserId: string;
  authorName: string;
  createdAt: string;
  updatedAt?: string | null;
  canManage?: boolean;
}

export interface CreateTeamNewsRequest {
  title: string;
  body: string;
  imageUrl?: string | null;
  sendNotification?: boolean;
}

export interface UpdateTeamNewsRequest {
  title: string;
  body: string;
  imageUrl?: string | null;
}

export interface CreateTeamRequest {
  name: string;
  description?: string | null;
  visibility: TeamVisibility;
  avatarUrl?: string | null;
  coverImageUrl?: string | null;
  phones?: TeamContactItem[];
  links?: TeamContactItem[];
  addresses?: TeamContactItem[];
}

export interface JoinTeamByCodeRequest {
  code: string;
  teamJerseyNumber?: number | null;
}

export interface UpdateTeamMemberRequest {
  role?: number | null;
  badgeTitle?: string | null;
  teamJerseyNumber?: number | null;
}

export interface UpdateTeamRequest {
  name: string;
  description?: string | null;
  visibility: TeamVisibility;
  avatarUrl?: string | null;
  coverImageUrl?: string | null;
  phones?: TeamContactItem[];
  links?: TeamContactItem[];
  addresses?: TeamContactItem[];
  allowDuplicateJerseyNumbers: boolean;
  blockedJerseyNumbers: number[];
}

export enum TeamTableTemplateType {
  PlayerStats = 1,
}

export interface TeamTableSummaryDto {
  id: string;
  teamId: string;
  teamName: string;
  name: string;
  templateType: TeamTableTemplateType;
  canManage: boolean;
  createdAt: string;
  rowsCount: number;
}

export interface TeamTableDto {
  id: string;
  teamId: string;
  teamName: string;
  name: string;
  templateType: TeamTableTemplateType;
  canManage: boolean;
  createdAt: string;
  rows: TeamTableRowDto[];
}

export interface TeamTableRowDto {
  id: string;
  userId: string;
  playerName: string;
  jerseyNumber?: number | null;
  photoUrl?: string | null;
  games: number;
  goals: number;
  assists: number;
  points: number;
}

export interface CreateTeamTableRequest {
  name: string;
  templateType: TeamTableTemplateType;
}

export interface EventTableProtocolDto {
  id: string;
  eventId: string;
  eventTitle: string;
  teamTableId: string;
  teamTableName: string;
  canManage: boolean;
  createdAt: string;
  rows: EventTableProtocolRowDto[];
}

export interface EventTableProtocolRowDto {
  id: string;
  userId: string;
  playerName: string;
  jerseyNumber?: number | null;
  photoUrl?: string | null;
  games: number;
  goals: number;
  assists: number;
  points: number;
}

export interface CreateEventTableProtocolRequest {
  teamTableId: string;
}

export interface UpdateEventTableProtocolRowRequest {
  games: number;
  goals: number;
  assists: number;
}

export interface UpdateEventTableProtocolRequest {
  rows: Array<{
    rowId: string;
    games: number;
    goals: number;
    assists: number;
  }>;
}
